<template>
  <Checkbox :id="`transact-sso-checkbox`" v-model="checkboxValue" :disabled="!editMealPlan" binary>
    <template #label>
      {{ t('sites.singleSite.financialConfig.mealPlans.form.transactSSOCheckboxLable') }}</template
    >
  </Checkbox>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Checkbox } from '@centric-os/components/src/core/controls/checkbox';
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../../routes';

const props = defineProps<{
  institutionId?: string | undefined;
}>();

const emit = defineEmits<{
  'update:checked': [value: boolean];
}>();

const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

// Initialize checkbox value based on institutionId
const checkboxValue = ref<boolean>(Boolean(props.institutionId));

// Sync checkbox with institutionId when it changes (e.g., when form data loads asynchronously)
watch(
  () => props.institutionId,
  (newInstitutionId) => {
    if (newInstitutionId && !checkboxValue.value) {
      checkboxValue.value = true;
    }
  },
);

watch(checkboxValue, (newValue) => {
  emit('update:checked', Boolean(newValue));
});
</script>
